import { API_ENDPOINTS } from "@/configs";
import { track } from "@/lib/analytics";
import apiRequest from "@/lib/axios";
import { DailySpinResult, DailySpinStatus } from "@/types";

export const getDailySpinStatus = async (): Promise<DailySpinStatus> => {
  return apiRequest({
    method: "GET",
    url: API_ENDPOINTS.DAILY_SPIN.STATUS,
    errorMessage: "Failed to load the daily spin",
  });
};

export const spinDailyWheel = async (): Promise<DailySpinResult> => {
  return apiRequest<DailySpinResult>({
    method: "POST",
    url: API_ENDPOINTS.DAILY_SPIN.SPIN,
    errorMessage: "The spin could not be completed",
  }).then((res) => {
    track("daily_spin");
    return res;
  });
};
